import { combineReducers } from 'redux';
import token from './token'
import details from './details'
import cart from './cart'
import wishlist from './wishlist'

export default combineReducers({
    token,
    details,
    cart,
    wishlist
});


// WEBPACK FOOTER //
// ./src/reducers/account/index.js